import React from 'react';
import { Navigate } from 'react-router-dom';
import { useShopAdminAuth } from '../../context/ShopAdminAuthContext';
import ShopAdminDashboard from './ShopAdminDashboard';

/**
 * Index route for /shop-admin.
 * Role-based landing:
 *  - admin / manager → show the full Shop Admin Dashboard
 *  - supervisor / cashier → /shop-admin/pos
 *  - rider → /shop-admin/rider
 */
const ROLE_HOME = {
  supervisor: '/shop-admin/pos',
  cashier: '/shop-admin/pos',
  rider: '/shop-admin/rider',
};

export default function ShopAdminHome() {
  const { staff, loading } = useShopAdminAuth();
  if (loading) return null;
  if (!staff) return <Navigate to="/shop-admin/login" replace />;
  const target = ROLE_HOME[staff.role];
  if (target) return <Navigate to={target} replace />;
  return <ShopAdminDashboard />;
}
